import { DataTypeProvider } from '@devexpress/dx-react-grid';
import React from 'react';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { NRHandleEmptyCellValue } from '../../NRReactGridCustomComponents/CellComponent/CellComponent';

const UNSPECIFIED = 'UNSPECIFIED';

export const SSVCExploitationFormatter = ({ value }) => {
  const theme = useTheme();
  const { severityPalette, error } = theme.palette;

  if (!value || value === UNSPECIFIED) {
    return <NRHandleEmptyCellValue value={null} />;
  }

  const exploitationMap = {
    NONE: { label: 'None', color: 'textPrimary' },
    POC: { label: 'Public Poc', color: severityPalette[3].alt },
    ACTIVE: { label: 'Active', color: error.main }
  };

  const config = exploitationMap[value] || { label: value, color: 'textPrimary' };

  return (
    <Typography variant="body2" sx={{ color: config.color }}>
      {config.label}
    </Typography>
  );
};

export const SSVCAutomatableFormatter = ({ value }) => {
  const theme = useTheme();
  const { error } = theme.palette;

  if (value === null || value === undefined) {
    return <NRHandleEmptyCellValue value={null} />;
  }

  const label = value ? 'Yes' : 'No';
  const color = value ? error.main : 'textPrimary';

  return (
    <Typography variant="body2" sx={{ color }}>
      {label}
    </Typography>
  );
};

export const SSVCTechImpactFormatter = ({ value }) => {
  const theme = useTheme();
  const { severityPalette, error } = theme.palette;

  if (!value || value === UNSPECIFIED) {
    return <NRHandleEmptyCellValue value={null} />;
  }

  const impactMap = {
    PARTIAL: { label: 'Partial', color: severityPalette[3].alt },
    TOTAL: { label: 'Total', color: error.main }
  };

  const config = impactMap[value] || { label: value, color: 'textPrimary' };

  return (
    <Typography variant="body2" sx={{ color: config.color }}>
      {config.label}
    </Typography>
  );
};

export const NRSSVCExploitationProvider = props => <DataTypeProvider formatterComponent={SSVCExploitationFormatter} {...props} />;

export const NRSSVCAutomatableProvider = props => <DataTypeProvider formatterComponent={SSVCAutomatableFormatter} {...props} />;

export const NRSSVCTechImpactProvider = props => <DataTypeProvider formatterComponent={SSVCTechImpactFormatter} {...props} />;
